export interface SettingsState {
  data: Record<string, any>
  isLoading: boolean
  error: string | undefined
}

export enum SettingsActionTypes {
  FETCH_SETTINGS_PENDING = '@SETTINGS:FETCH_SETTINGS_PENDING',
  FETCH_SETTINGS_FULFILLED = '@SETTINGS:FETCH_SETTINGS_FULFILLED',
  FETCH_SETTINGS_REJECTED = '@SETTINGS:FETCH_SETTINGS_REJECTED',
  LOGOUT = '@SETTINGS:LOGOUT'
}
